"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentKeys = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
class ContentKeys {}
exports.ContentKeys = ContentKeys;
(0, _defineProperty2.default)(ContentKeys, "TermsAndConditions_Url", {
  id: 'TermsAndConditions_Url',
  value: ''
});
(0, _defineProperty2.default)(ContentKeys, "PrivacyPolicy_Url", {
  id: 'PrivacyPolicy_Url',
  value: ''
});
(0, _defineProperty2.default)(ContentKeys, "Benefit_Icon1", {
  id: 'Benefit_Icon1',
  value: ''
});
(0, _defineProperty2.default)(ContentKeys, "Benefit_Icon2", {
  id: 'Benefit_Icon2',
  value: ''
});
(0, _defineProperty2.default)(ContentKeys, "Benefit_Icon3", {
  id: 'Benefit_Icon3',
  value: ''
});
